<template>
	<div>
		<breadcrumb :list="breadcrumbList"></breadcrumb>
		<el-card class="main">
			<div class="subject">
				<el-row type="flex" class="subject_title" >
					<img src="@/assets/img/tag.png" alt="">
					<span class="title_text">基本信息</span>
				</el-row>

				<el-descriptions class="margin-top" :column="3" border labelClassName="labelWidth">
					<el-descriptions-item label="营业日志编号">{{}}</el-descriptions-item>
					<el-descriptions-item label="营业场所编号">{{}}</el-descriptions-item>
					<el-descriptions-item label="场所负责人">{{}}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="治安负责人"> {{}}</el-descriptions-item>
					<el-descriptions-item label="营业开始时间"> {{}}</el-descriptions-item>
					<el-descriptions-item label="营业结束时间"> {{}}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="是否有治安/刑事/事故"> {{}}</el-descriptions-item>
					<el-descriptions-item label="是否有管理部门检查"> {{}}</el-descriptions-item>
					<el-descriptions-item label="当日营业状态"> {{}}</el-descriptions-item>
					<!--  -->
					<el-descriptions-item label="创建人"> {{}}</el-descriptions-item>
					<el-descriptions-item label="创建人账号"> {{}}</el-descriptions-item>
					<el-descriptions-item label="创建时间"> {{}}</el-descriptions-item>
					<!--  -->

					<!--  -->
				</el-descriptions>
			</div>
			<div class="subject_btn" style="text-align:center;margin-top: 56px;">
				<el-button type="primary" @click="$router.back(-1)" class="go_back">返回</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
export default {
	name: 'EmployeesDetailsVue',
	data() {
		return {
			breadcrumbList: [
				{ name: "日常工作", path: "day_work" },
				{ name: "营业日志", path: "bus_log" },
				{ name: "查看", path: "bus_log_details" }
			],
			list: []
		}
	}
}
</script>

<style lang="less" scoped>
.main {
	margin: 20px;
	padding: 22px 20px;

	.subject {
		.subject_title {
			margin-bottom: 23px;
			img {
				width: 30px;
				height: 39px;
				margin-right: 3px;
			}

			.title_text {
				font-size: 18px;
				line-height: 36px;
				font-family: Source Han Sans SC;
				font-weight: bold;
				color: #6345D5;
			}
		}
	}

	/deep/ .labelWidth {
		width: 150px;
	}

	.go_back {
		width: 80px;
		height: 50px;
		background: #FFFFFF;
		border: 1px solid #6345D5;
		border-radius: 6px;
		color: #6345D5;
	}
}
</style>
